import { useEffect, useState } from 'react';
import TableHeaderDateRange from '@/components/data-table/TableHeaderDateRange';
import TableHeaderDropdownSearch from '@/components/data-table/TableHeaderDropdownSearch';
import TableHeaderSearch from '@/components/data-table/TableHeaderSearch';
import TableHeaderSort from '@/components/data-table/TableHeaderSort';
import TableHeaderTitle from '@/components/data-table/TableHeaderTitle';

const asList = (value) => (Array.isArray(value) ? value : value ? String(value).split(',') : []);

/**
 * Column headers as on the other lists ("Svi zaposleni"): a search, choice
 * or date funnel and the sort arrows, all written into the address and
 * answered by the server.
 *
 * @param {Object} queryParams
 * @param {Function} setQueryParams
 * @param {string[]} keys - Every filterable column, to hold its draft value.
 * @returns {{ text, options, date, sort }} Title renderers by kind.
 */
export default function useColumnHeaders(queryParams, setQueryParams, keys) {
  const [open, setOpen] = useState({});
  const [draft, setDraft] = useState({});

  useEffect(() => {
    setDraft(Object.fromEntries(keys.map((k) => [k, queryParams[k]])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);

  const onClose = (name, value) => setOpen((prev) => ({ ...prev, [name]: value }));
  const onChange = (name, value) => setDraft((prev) => ({ ...prev, [name]: value }));
  const onReset = (name) => {
    setQueryParams({ [name]: undefined, offset: 1 });
    setDraft((prev) => ({ ...prev, [name]: undefined }));
    onClose(name, false);
  };
  const onSubmit = (name, values) => {
    const value = values[name];
    onClose(name, false);
    setQueryParams({ [name]: value && value.length ? value : undefined, offset: 1 });
  };
  const shared = { searchTerm: draft, toggleDropdown: open, onChange, onSubmit, onReset, onClose };

  return {
    text: (dataIndex, title) => () => (
      <TableHeaderTitle title={title}>
        <TableHeaderSearch dataIndex={dataIndex} title={title} {...shared} />
        <TableHeaderSort dataIndex={dataIndex} />
      </TableHeaderTitle>
    ),
    options: (dataIndex, title, options) => () => (
      <TableHeaderTitle title={title}>
        <TableHeaderDropdownSearch
          dataIndex={dataIndex}
          title={title}
          options={options}
          {...shared}
          searchTerm={{ ...draft, [dataIndex]: asList(draft[dataIndex]) }}
        />
        <TableHeaderSort dataIndex={dataIndex} />
      </TableHeaderTitle>
    ),
    date: (dataIndex, title) => () => (
      <TableHeaderTitle title={title}>
        <TableHeaderDateRange dataIndex={dataIndex} title={title} />
        <TableHeaderSort dataIndex={dataIndex} />
      </TableHeaderTitle>
    ),
    sort: (dataIndex, title) => () => (
      <TableHeaderTitle title={title}>
        <TableHeaderSort dataIndex={dataIndex} />
      </TableHeaderTitle>
    ),
  };
}
